/* global axios */
import ApiClient from './ApiClient';

class AppointmentsAPI extends ApiClient {
  constructor() {
    super('appointments', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  complete(id) {
    return axios.post(`${this.url}/${id}/complete`);
  }

  cancel(id) {
    return axios.post(`${this.url}/${id}/cancel`);
  }

  sendReminder(id, data = {}) {
    return axios.post(`${this.url}/${id}/send_reminder`, data);
  }

  upcoming() {
    return axios.get(`${this.url}/upcoming`);
  }

  // Reminders
  getReminders(appointmentId) {
    return axios.get(`${this.url}/${appointmentId}/reminders`);
  }

  createReminder(appointmentId, data) {
    return axios.post(`${this.url}/${appointmentId}/reminders`, data);
  }

  updateReminder(appointmentId, reminderId, data) {
    return axios.patch(
      `${this.url}/${appointmentId}/reminders/${reminderId}`,
      data
    );
  }

  deleteReminder(appointmentId, reminderId) {
    return axios.delete(`${this.url}/${appointmentId}/reminders/${reminderId}`);
  }
}

export default new AppointmentsAPI();
